import { Text } from "@clipboard-health/ui-components";
// eslint-disable-next-line no-restricted-imports
import Markdown from "markdown-to-jsx";
import { Fragment } from "react";

interface EmphasizedTextProps {
  text: string;
}

/**
 * Renders mostly plain text with support for bold and italics text using a subset of Markdown.
 * Text wrapped in two asterisks (e.g., **Agency ID**) will be rendered as bold, centered H1-like text.
 * Text wrapped in one asterisk (e.g., *Building name*) will be rendered as italic.
 * Regular text and other Markdown tags will be rendered as text components.
 */
export function EmphasizedText(props: EmphasizedTextProps) {
  const { text } = props;

  if (text.trim().length === 0) {
    return null;
  }

  // force all **s into their own paragraphs
  const textWithNewLines = text.replace(/\*\*(.+?)\*\*/g, "\n\n**$1**\n\n");

  return (
    <Markdown
      options={{
        wrapper: Fragment,
        forceBlock: true,
        overrides: {
          p: { component: Text },
          strong: {
            component: Text,
            props: {
              bold: true,
              variant: "h1",
              textAlign: "center",
              inline: true,
              sx: {
                display: "block",
              },
            },
          },
          em: {
            component: Text,
            props: {
              inline: true,
              italic: true,
            },
          },

          // disable all other tags
          h1: { component: Text },
          h2: { component: Text },
          h3: { component: Text },
          h4: { component: Text },
          h5: { component: Text },
          h6: { component: Text },
          blockquote: { component: Text },
          ul: { component: Text },
          ol: { component: Text },
          li: {
            component: Text,
            props: {
              inline: true,
            },
          },
          pre: { component: Text },
          code: { component: Text },
          hr: { component: Text },
          table: { component: Text },
          thead: { component: Text },
          tbody: { component: Text },
          tr: { component: Text },
          td: { component: Text },
          th: { component: Text },
          style: () => null,
          iframe: () => null,
          script: () => null,
          object: () => null,
        },
      }}
    >
      {textWithNewLines}
    </Markdown>
  );
}
